import styled from 'styled-components';

export const InputAffixWrapper = styled.div`
  position: relative;
`;

export const CalendarIconButton = styled.button<{ $disabled?: boolean }>`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutral600};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};
  line-height: 0;

  svg {
    width: 20px;
    height: 20px;
    display: block;
  }

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.primary600};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary600};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const CalendarPopover = styled.div`
  position: absolute;
  z-index: 20;
  right: 0;
  top: calc(100% + 4px);
  min-width: 280px;
  padding: 12px;
  background: ${({ theme }) => theme.colors.neutral};
  border: 1px solid ${({ theme }) => theme.colors.neutral100};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(40, 43, 46, 0.12);
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const CalendarTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral900};
  text-transform: capitalize;
`;

export const CalendarNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutral700};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.neutral50};
    color: ${({ theme }) => theme.colors.primary600};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary600};
    outline-offset: 1px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;
`;

export const WeekdayCell = styled.span`
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral500};
  padding: 4px 0;
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const DayCell = styled.button<{
  $outsideMonth?: boolean;
  $selected?: boolean;
  $isToday?: boolean;
}>`
  aspect-ratio: 1;
  min-width: 0;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: ${({ theme, $selected }) =>
    $selected ? theme.colors.primary600 : 'transparent'};
  color: ${({ theme, $selected, $outsideMonth }) => {
    if ($selected) return theme.colors.neutral;
    if ($outsideMonth) return theme.colors.neutral400;
    return theme.colors.neutral800;
  }};
  font-size: 13px;
  cursor: pointer;
  opacity: ${({ $outsideMonth }) => ($outsideMonth ? 0.5 : 1)};

  ${({ theme, $isToday, $selected }) =>
    $isToday && !$selected
      ? `
    border-color: ${theme.colors.primary600};
    font-weight: 600;
  `
      : ''}

  &:hover:not(:disabled) {
    background: ${({ theme, $selected }) =>
      $selected ? theme.colors.primary700 : theme.colors.neutral50};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary600};
    outline-offset: 1px;
  }
`;
